var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"fsb-range-input",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"change":(e) => _vm.$emit('input', e.target.value || null)}})
}
var staticRenderFns = []

export { render, staticRenderFns }